import formatDate from "@Utils/formatDate";

export const appendZeroBeforeSingleDigit = (value: any): string => {
  if (parseInt(value, 10) < 10) {
    return `0${value}`;
  }
  return `${value}`;
};

export const sizeToAppend = 5;
export const addIndex = (arr: any, index: any, labelModifier?: any): any => {
  const finalArray = arr.reduce((acc: any, option: any) => {
    acc.push({
      index,
      value: option,
      label: labelModifier ? labelModifier(option) : option,
    });
    return acc;
  }, []);
  return finalArray;
};

export const getDaysArr = (
  month: any,
  year: any,
  maxYear: any,
  minYear: any,
  isWeb = false,
): Array<string> => {
  const dateObj = new Date();
  if (
    maxYear &&
    maxYear.toString() === year.toString() &&
    month === new Date().getMonth() &&
    !(dateObj.getDate() === 1 && dateObj.getMonth() === 0)
  ) {
    return [...new Array(new Date().getDate() - 1)].map((...args) =>
      isWeb ? `${args[1] + 1}` : appendZeroBeforeSingleDigit(args[1] + 1),
    );
  }

  if (
    minYear &&
    minYear.toString() === year.toString() &&
    month === 0 &&
    !(dateObj.getDate() === 31 && dateObj.getMonth() === 11)
  ) {
    return [
      ...new Array(
        new Date(year, 12 - getMonthArr(minYear, maxYear, year).length + 1, 0).getDate() -
          new Date().getDate(),
      ),
    ].map((...args) => appendZeroBeforeSingleDigit(args[1] + 1 + new Date().getDate()));
  }

  if (
    minYear &&
    minYear.toString() === year.toString() &&
    month > 0 &&
    !(dateObj.getDate() === 31 && dateObj.getMonth() === 11)
  ) {
    return [
      ...new Array(
        new Date(
          year.toString(),
          12 - getMonthArr(minYear, maxYear, year).length + month + 1,
          0,
        ).getDate(),
      ),
    ].map((...args) => appendZeroBeforeSingleDigit(args[1] + 1));
  }

  return [...new Array(new Date(year.toString(), (month + 1).toString(), 0).getDate())].map(
    (...args) => (isWeb ? `${args[1] + 1}` : appendZeroBeforeSingleDigit(args[1] + 1)),
  );
};

export const monthsArray = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const shortMonthsArray = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "July",
  "Aug",
  "Sept",
  "Oct",
  "Nov",
  "Dec",
];

export const getMonthArr = (minYear: any, maxYear: any, currentYear: any): Array<string> => {
  if (maxYear && maxYear.toString() === currentYear.toString()) {
    const { month } = getMaxDateObject(1, 0, maxYear);
    return monthsArray.slice(0, parseInt(month, 10) + 1);
  }
  if (minYear && minYear.toString() === currentYear.toString()) {
    const { month } = getMinDateObject(1, 0, minYear);
    return monthsArray.slice(parseInt(month, 10), monthsArray.length + 1);
  }
  return monthsArray;
};

export const getYearArr = (max: any, min: any): Array<number> =>
  [...new Array(Number(max || new Date().getFullYear()) - Number(min ? min - 1 : 1900))].map(
    (...args) => args[1] + Number(min ? min - 1 : 1900) + 1,
  );

export const getDate = (currentDate: any, toDisplay = false): string => {
  const date = formatDate(new Date(currentDate));

  if (toDisplay) {
    return `${parseInt(date.day, 10) < 10 ? `0${date.day}` : date.day}/${date.monthNumber}/${
      date.year
    }`;
  }

  return `${date.year}-${date.monthNumber}-${
    parseInt(date.day, 10) < 10 ? `0${date.day}` : date.day
  }`;
};

interface DateObj {
  day: string;
  year: string;
  month: string;
}

const getDateObj = (date: any, isDesktop = false): DateObj => {
  const { day, year, monthNumber } = date;
  return {
    day: isDesktop ? `${day}` : appendZeroBeforeSingleDigit(day),
    year: `${year}`,
    month: `${parseInt(monthNumber, 10) - 1}`,
  };
};

export const getMaxDateString = (days: any, month: any, year: any): Date => {
  const date = new Date();
  date.setDate(date.getDate() - days);
  date.setMonth(date.getMonth() - month);
  date.setFullYear(date.getFullYear() - year);

  return date;
};

export const getMinDateString = (days: any, month: any, year: any): Date => {
  const date = new Date();
  date.setDate(date.getDate() + days);
  date.setMonth(date.getMonth() - month);
  date.setFullYear(date.getFullYear() - year);

  return date;
};

export const getMaxDateObject = (days: any, month: any, year: any, isDesktop = false): DateObj => {
  const date = getMaxDateString(days, month, year);

  const maxDate = formatDate(new Date(date));
  return { ...getDateObj(maxDate, isDesktop) };
};

export const getMinDateObject = (days: any, month: any, year: any): DateObj => {
  const date = getMinDateString(days, month, year);

  const minDate = formatDate(new Date(date));
  return { ...getDateObj(minDate) };
};

export const getObjectFromDate = (currentDate: any, isDesktop = false): DateObj => {
  if (currentDate) {
    const date = formatDate(new Date(currentDate));
    return { ...getDateObj(date, isDesktop) };
  }
  return getMaxDateObject(1, 0, 21);
};

export const getMaxDate = (days: any, month: any, year: any): string => {
  const date = getMaxDateString(days, month, year);
  return getDate(date);
};

export const daysName = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];
